import { createAction, props } from '@ngrx/store';


export const getServiceInfo = createAction(
  '[CostModule] Get Service Info',
  props<{unitIds: number[]}>()
);

export type CostModuleActionsUnion = ReturnType<
  typeof getServiceInfo
>;
